import { PROMPT_DOWNLOAD_FORMATS } from 'core/constants/general'
import { useTranslation } from 'react-i18next'
import Card from 'core/components/common/Card'
import { ReactComponent as CSVIcon } from 'core/assets/images/documents/csvIcon.svg'

export const PromptFormatSelector: React.FC<{
  value: string[] | null | undefined
  onChange: (val: string[] | null) => void
}> = ({ value, onChange }) => {
  const formats = PROMPT_DOWNLOAD_FORMATS
  const { t } = useTranslation()
  const selected = Array.isArray(value) ? value : []

  const toggleFormat = (format: string | null) => {
    if (format === null) {
      onChange(null)
    } else {
      if (value === null) {
        onChange([format])
      } else {
        const alreadySelected = selected.includes(format)
        const newSelected = alreadySelected
          ? selected.filter((f) => f !== format)
          : [...selected, format]
        onChange(newSelected.length === 0 ? null : newSelected)
      }
    }
  }

  const isSelected = (format: string) =>
    Array.isArray(value) && value.includes(format)

  return (
    <div className="grid grid-cols-2 gap-[10px]">
      <Card
        className={`card-prompt-format ${value === null ? 'card-selected' : ''}`}
        onClick={() => toggleFormat(null)}
      >
        {t('prompts.form.noFile')}
      </Card>
      {formats.map((format) => (
        <Card
          key={format}
          className={`card-prompt-format ${isSelected(format) ? 'card-selected' : ''}`}
          onClick={() => toggleFormat(format)}
        >
          <CSVIcon className="mr-[20px]" />
          <div>
            {t('prompts.form.fileLabel')}&nbsp;.{format}
          </div>
        </Card>
      ))}
    </div>
  )
}
